<template>
  <div>
    <el-card body-style="padding: 0">
      <el-form ref="queryForm" :model="queryForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="系统订单" prop="systemOrderNum">
              <el-input v-model="queryForm.systemOrderNum" placeholder="请输入系统订单号"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台订单" prop="plateformOrderNum">
              <el-input v-model="queryForm.plateformOrderNum" placeholder="平台订单号"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="任务编号" prop="taskNum">
              <el-input v-model="queryForm.taskName" placeholder="请输入任务名称"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="商家用户名" prop="businessUserName">
              <el-input v-model="queryForm.businessUserName" placeholder="请输入商家名"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="店铺名称" prop="shopName">
              <el-input v-model="queryForm.shopName" placeholder="请输入店铺名"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="试客用户名" prop="userName">
              <el-input v-model="queryForm.userName" placeholder="请输入试客名"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="试客平台账号" prop="plateformUserName">
              <el-input v-model="queryForm.plateformUserName" placeholder="请输入试客平台账号"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="任务类型" prop="tasktype">
              <el-select v-model="queryForm.tasktype" clearable placeholder="请选择任务类型">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="接单时间" prop="orderTime">
              <el-select v-model="queryForm.orderTime" clearable placeholder="请选择接单时间">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="时间段" prop="timeRange">
              <el-date-picker
                  v-model="queryForm.timeRange"
                  type="daterange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="返款状态" prop="moneyReturnStatus">
              <el-select v-model="queryForm.moneyReturnStatus" clearable placeholder="请选择">
                <el-option
                    v-for="item in returnStatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" >
            <el-form-item>
              <el-button type="primary" size="small"
                         @click="submitQueryForm()" icon="el-icon-search">
                查询</el-button>
              <el-button type="primary" size="small" plain
                         @click="resetQueryForm()" icon="el-icon-refresh">
                重置</el-button>
              <el-button type="primary" size="small" plain
                         @click="importData()" icon="el-icon-refresh">
                导出</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card>
    <el-table :data="tableData"
              border default-expand-all stripe
              :header-cell-style="{'text-align':'center'}"
              style="width: 100%;margin-bottom: 20px;"
              :cell-style="{'text-align':'center'}"
              @selection-change="handleSelectionChange">
      <el-table-column label="全选" width="50" type="selection"/>
      <el-table-column prop="orderId" label="订单编号">
        <template slot-scope="scope">
          <router-link :to="{path:'/home/taskorderdetail', query:{orderId:scope.row.orderId, taskNumbers:null}}">
            <span style="color: #04befe">{{ getStrEndWithNumbers(scope.row.orderId) }}</span>
          </router-link>
        </template>
      </el-table-column>
      <el-table-column prop="taskType" label="任务类型"/>
      <el-table-column prop="plateformOrderNumbers" label="平台单号"/>
      <el-table-column prop="taskId" label="任务编号">
        <template slot-scope="scope">
          <router-link :to="{path:'/home/businesstaskdetails', query: {b2cTaskId:scope.row.taskId}}">
            <span style="color: #04befe">{{ getStrEndWithNumbers(scope.row.orderId) }}</span>
          </router-link>
        </template>
      </el-table-column>
      <el-table-column prop="businessStoreName" label="商家">
        <template slot-scope="scope">
          <router-link :to="{path:'/home/storedetail', query: {userId:scope.row.bussinessStoreId}}">
            <span style="color: #04befe">{{ scope.row.businessStoreName }}</span>
          </router-link>
        </template>
      </el-table-column>
      <el-table-column prop="customerName" label="试客">
        <template slot-scope="scope">
          <router-link :to="{path:'/home/customerdetail', query: {customerId:scope.row.customerId}}">
            <span style="color: #04befe">{{ scope.row.customerName }}</span>
          </router-link>
        </template>
      </el-table-column>
      <el-table-column prop="shopName" label="店铺"/>
      <el-table-column prop="orderMoneyInfo" label="订单金额"/>
      <el-table-column prop="beginTime" label="开始时间"/>
      <el-table-column prop="endTime" label="结束时间"/>
      <el-table-column prop="statusStr" label="订单状态"/>
      <el-table-column prop="orderRemarks" label="订单备注"/>
      <el-table-column prop="ownerWeb" label="所属分站"/>
      <el-table-column label="操作" width="280" align="center">
        <template slot-scope="scope">
          <el-row>
            <el-col :span="24" style="margin-top: 5px;">
              <el-button size="mini" type="success" plain
                         v-if="scope.row.isAssignBusiness && scope.row.statusStr == '待接单'"
                         @click="handleAssignEdit(scope.$index, scope.row,'指派-'+scope.row.taskType)">
                指派
              </el-button>
              <el-button size="mini" type="success" plain
                         v-if="scope.row.statusStr !== '已完成' && scope.row.statusStr !== '已取消'"
                         @click="handleEdit(scope.$index, scope.row,'订单结算-'+getStrEndWithNumbers(scope.row.orderId))">
                结算
              </el-button>
              <el-button size="mini" type="primary" plain
                         @click="goToOrderDetail(scope.$index, scope.row)">
                查看
              </el-button>
              <el-button size="mini" type="primary" plain
                         @click="handleEdit(scope.$index, scope.row,'修改字典项')">
                日志
              </el-button>
              <el-button size="mini" type="primary" plain
                         @click="handleRemarksEdit(scope.$index, scope.row,'设置备注')">
                备注
              </el-button>
            </el-col>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        :page-sizes="[20, 50, 100, 200]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        @size-change="handlePageSizeChange"
        @current-change="handlePageNumChange"
        background
        style="float: right;margin-bottom: 10px">
    </el-pagination>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
      <el-form ref="dialogForm" :model="dialogForm" label-width="220px">
        <el-form-item label="开始时间">
          <span>{{ dialogForm.beginTime }}</span>
        </el-form-item>
        <el-form-item label="订单编号">
          <span>{{ dialogForm.orderId }}</span>
        </el-form-item>
        <el-form-item label="订单商家">
          <span>{{ dialogForm.businessStoreName }}</span>
        </el-form-item>
        <el-form-item label="订单试客">
          <span>{{ dialogForm.customerName }}</span>
        </el-form-item>
        <el-form-item label="返款类型">
          <span>{{ dialogForm.returnType }}</span>
        </el-form-item>
        <el-form-item label="本金返款">
          <span>{{ dialogForm.moneyReturn }}</span>
        </el-form-item>
        <el-form-item label="本金返款状态">
          <span>{{ dialogForm.moneyReturnStatus ? "已返款" : "未返款" }}</span>
        </el-form-item>
        <el-form-item label="佣金返款状态">
          <span>{{ dialogForm.comissionReturnStatus ? "已返款" : "未返款" }}</span>
        </el-form-item>
        <el-form-item label="订单金额">
        <span style="color: red;">
          <span>本金：{{ dialogForm.money }}</span>
          <span style="margin-left: 1%;">运费：{{ dialogForm.expressMoney }}</span>
          <span style="margin-left: 1%;">服务费：{{ dialogForm.serviceMoney }}</span>
          <span style="margin-left: 1%;">佣金：{{ dialogForm.commission }}</span>
          <span style="margin-left: 1%;">空包费：0.0</span>
          <span style="margin-left: 1%;">赏金：{{ dialogForm.moreServiceMoney }}</span>
          <span style="margin-left: 1%;">合计：{{ dialogForm.totalMoney }}</span>
        </span>
        </el-form-item>
        <el-form-item label="可结算金额">
          <span style="color: red">{{ dialogForm.totalMoney }}</span>
        </el-form-item>
        <el-form-item label="试客金额">
          <el-input v-model="dialogForm.customerMoney" style="width: 50%;" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="商家金额">
          <el-input v-model="dialogForm.businessStoreMoney" style="width: 50%;" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="结算状态">
          <el-radio-group v-model="dialogForm.orderStatus">
            <el-radio :label="202109030005">取消订单</el-radio>
            <el-radio :label="202109030004">完成订单</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="dialogForm.orderRemarks" style="width: 50%;" size="mini"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitCanculateDialogForm" size="mini" type="primary">结算</el-button>
        <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="dialogBusinessTitle" :visible.sync="dialogBusinessFormVisible">
      <el-form ref="dialogBusinessForm" :model="dialogBusinessForm" label-width="220px">
        <el-form-item label="备注">
          <el-input v-model="dialogBusinessForm.remarks" style="width: 50%;" size="mini"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitDialogBusinessForm()" size="mini" type="primary">提交</el-button>
        <el-button @click="handleBusinessCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="dialogAssignTitle" :visible.sync="dialogAssignFormVisible">
      <el-form ref="dialogAssignForm" :model="dialogAssignForm" label-width="220px">
        <el-form-item label="账号">
          <el-input v-model="dialogAssignForm.userName" placeholder="请输入指派账号信息" style="width: 50%;"
                    size="mini"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitDialogAssifnForm" size="mini" type="primary">指派</el-button>
        <el-button @click="handleAssignCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  addOrderRemarks,
  assignOrderToCustomer,
  changeMoneyLogs,
  getAdminOrderVoList, getOrderMoneyInfo
} from "../../api/b2cbusiness/b2c_orderlist";
import {getStrEndWithNumbers} from "../../lib/utils";
import MixinCUD from "../../components/MixinCUD";

export default {
  name: "WaitBusinessReturnMoney",
  mixins: [MixinCUD],
  data() {
    return {
      tableData: [],
      queryForm: {
        moneyReturnStatus:false
      },
      options:[],
      returnStatus:[
        {
          label:"商家已返款",
          value: true,
        },
        {
          label:"商家未返款",
          value: false,
        }
      ],
      dialogFormVisible: false,
      dialogTitle: "",
      dialogRefName: "dialogForm",
      dialogForm: {},
      dialogBusinessFormVisible: false,
      dialogBusinessTitle: "",
      dialogBusinessRefName: "dialogBusinessForm",
      dialogBusinessForm: {},
      dialogAssignFormVisible: false,
      dialogAssignTitle: "",
      dialogAssignRefName: "dialogAssignForm",
      dialogAssignForm: {},
      orderStatus: this.orderStatus,
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  mounted() {
    if(this.$route.query.moneyReturnStatus != undefined && this.$route.query.moneyReturnStatus != null){
      this.queryForm.moneyReturnStatus = this.$route.query.moneyReturnStatus;
      console.log(this.queryForm)
    }
    this.getData();
  },
  methods: {
    submitDialogAssifnForm() {
      this.$refs[this.dialogAssignRefName].validate((valid) => {
        if (valid) {
          this.$confirm("该订单开始时间还没到,确认继续指派该订单吗?")
              .then(_ => {
                assignOrderToCustomer(this.dialogAssignForm).then(res => {
                  if (res.success) {
                    this.dialogAssignFormVisible = false;
                    this.$message.success("更新数据成功！")
                    this.getData();
                    this.$forceUpdate();
                  }
                });
                //取消新增或修改也要重置表单
              }).catch(err => {
            this.handleCloseDialog();
          });
        } else {
          return false;
        }
      });
    },
    submitCanculateDialogForm() {
      this.$refs[this.dialogRefName].validate((valid) => {
        if (valid) {
          this.$confirm("确定提交数据么?")
              .then(_ => {
                changeMoneyLogs(this.dialogForm).then(res => {
                  if (res.success) {
                    this.dialogFormVisible = false;
                    this.$message.success("更新数据成功！")
                    this.getData();
                    this.$forceUpdate();
                  }
                });
                //取消新增或修改也要重置表单
              }).catch(err => {
            this.handleCloseDialog();
          });
        } else {
          return false;
        }
      });
    },
    handleAssignEdit(index, row, title) {
      this.dialogAssignFormVisible = true;
      this.dialogAssignTitle = title
      this.resetDialogAssignForm()
      this.dialogAssignForm = {...row}
    },
    changeOrderTabs(tab) {
      console.log("changeOrderTabs----", tab)
      getAdminOrderVoList({status: tab.value}, this.pagination).then(res => {
        if (res.success) {
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    getData() {
      getAdminOrderVoList(this.queryForm, this.pagination).then(res => {
        if (res.success) {
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    submitDialogBusinessForm() {
      this.$refs[this.dialogBusinessRefName].validate((valid) => {
        if (valid) {
          console.log(this.dialogBusinessForm);
          this.$confirm("确定提交数据么?")
              .then(_ => {
                console.log(this.dialogBusinessForm);
                addOrderRemarks(this.dialogBusinessForm).then(res => {
                  if (res.success) {
                    this.dialogBusinessFormVisible = false;
                    this.$message.success("更新数据成功！")
                    this.getData();
                    this.$forceUpdate();
                  }
                }).catch(err => {
                  this.$message({message: err.message, type: 'error'});
                })
                //取消新增或修改也要重置表单
              }).catch(err => {
            this.handleBusinessCloseDialog();
          });
        } else {
          return false;
        }
      });
    },
    resetDialogBusinessForm() {
      for (let item in this.dialogBusinessForm) {
        if (typeof this.dialogBusinessForm[item] === 'string') {
          this.dialogBusinessForm[item] = '';
        } else if (this.dialogBusinessForm[item] instanceof Array) {
          this.dialogBusinessForm[item] = [];
        } else {
          this.dialogBusinessForm[item] = null
        }
      }
    },
    resetDialogAssignForm() {
      for (let item in this.dialogAssignForm) {
        if (typeof this.dialogAssignForm[item] === 'string') {
          this.dialogAssignForm[item] = '';
        } else if (this.dialogAssignForm[item] instanceof Array) {
          this.dialogAssignForm[item] = [];
        } else {
          this.dialogAssignForm[item] = null
        }
      }
    },
    handleBusinessCloseDialog() {
      this.$refs[this.dialogBusinessRefName].resetFields();
      this.dialogBusinessFormVisible = false;
    },
    handleAssignCloseDialog() {
      this.$refs[this.dialogAssignRefName].resetFields();
      this.dialogAssignFormVisible = false;
    },
    handleEdit(index, row, dialogTitle) {
      this.dialogFormVisible = true;
      this.dialogTitle = dialogTitle
      this.resetDialogForm()
      this.dialogForm = {...row}
      getOrderMoneyInfo(row).then(res => {
        if (res.success) {
          this.dialogForm = {...this.dialogForm, ...res.data}
          this.$forceUpdate();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    handleRemarksEdit(index, row, title) {
      this.dialogBusinessFormVisible = true;
      this.dialogBusinessTitle = title
      this.resetDialogBusinessForm()
      this.dialogBusinessForm = {...row}
      console.log(this.dialogBusinessForm)
    },
    goToOrderDetail(index, row) {
      this.$router.push({path: '/home/taskorderdetail', query: {orderId: row.orderId, taskNumbers: null}});
    },
    getStrEndWithNumbers(numbers) {
      return getStrEndWithNumbers(numbers, 8);
    },
    handlePageSizeChange(val) {
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val) {
      this.pagination.pageNum = val;
      this.submitQueryForm()
    },
  },
}
</script>

<style lang="scss" scoped>
.el-form {
  margin-top: 20px;
}
</style>
